import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorTransformerService } from '@app/shared/services/error-transformer.service';
import { ErrorToastService } from '@app/shared/toasts/error-toast-service';
import { Logger } from '@app/utils/logger';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: Error): void {
    Logger.error(error);

    const errorToastService = this.injector.get(ErrorToastService);
    const translateService = this.injector.get(TranslateService);
    const description = this.injector.get(ErrorTransformerService).describeError(error);

    if (description != null) {
      const title = description.title ?? description.details?.title;
      const message = description.message ?? description.details?.message;

      if (title != null && message != null) {
        errorToastService.show(translateService.instant(title), translateService.instant(message));
      } else {
        errorToastService.show(translateService.instant(title ?? message));
      }
    } else {
      errorToastService.show(translateService.instant('error'), error.message);
    }
  }
}
